import { useCallback } from "react";
import { useSaveShippingCostMutation } from "../mutations/useSaveShippingCost.mutation";
import { ShippingCost } from "../../../interfaces/shippingCostType";

export const useSaveShippingCost = () => {
  const saveMutation = useSaveShippingCostMutation();

  const handleSave = useCallback(
    (values: ShippingCost) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
